import { Button, makeStyles } from '@material-ui/core';
import React from 'react';

interface SelectorButtonProps<T> {
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => T;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.primary,
    fontSize: '12px',
  },
}));

// Module-level defaults keep the same referential identity across renders that
// defaultProps provided (inline defaults would create new instances per render).
const noop = () => undefined;
const emptyStyle: React.CSSProperties = {};

const SelectorButton: React.FC<SelectorButtonProps<unknown>> = ({
  children,
  disabled = false,
  onClick = noop,
  style = emptyStyle,
}) => {
  const { root } = useStyles();
  return (
    <Button
      size="small"
      disabled={disabled}
      onClick={onClick}
      style={{ padding: 0, ...style }}
      className={root}
    >
      {children}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20px"
        viewBox="0 -960 960 960"
        width="20px"
        fill="currentColor"
        style={{ marginLeft: '12px' }}
      >
        <path d="M461-403 318.88-545.19q-2.94-2.95-4.41-6.38Q313-555 313-558.5q0-7 4.95-12.25T331-576h298q8.1 0 13.05 5.4Q647-565.2 647-558q0 1-5.88 12.77L499-403q-4 4-9 6t-10 2q-5 0-10-2t-9-6Z" />
      </svg>
    </Button>
  );
};

export default SelectorButton;
